<template>
    <ul class="owl-carousel" :id="id" ref="owlCarouselView">
      <slot></slot>
    </ul>
</template>

<script>
import $ from 'jquery'
import 'owl.carousel/dist/assets/owl.carousel.css'
import 'owl.carousel/dist/assets/owl.theme.default.css'
import 'owl.carousel'
import Vue from 'vue'

export default {
  name: 'Carousel',
  props: {
    dots: Boolean
  },
  data () {
    return {
      id: '',
      loaded: false
    }
  },
  mounted () {
    this.id = `carousel-${this._uid}`
  },
  methods: {
    applyOwlCarousel: function () {
      Vue.nextTick(() => {
        const owl = $('#' + this.id)

        owl.owlCarousel({
          loop: false,
          margin: 10,
          nav: true,
          dots: this.dots,
          responsive: {
            0: {
              items: 1,
              dots: false
            },
            1024: {
              items: 2,
              dots: false
            },
            1200: {
              items: 3
            }
          }
        })
      })
    }
  }
}
</script>

<style scoped>
  .loading-carousel {
    min-height: 100px;
  }
</style>
